import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    fiberPlans: [
      { speed: "50 Mbps", price: "999" },
      { speed: "100 Mbps", price: "1,299" },
      { speed: "200 Mbps", price: "1,499", popular: true },
      { speed: "300 Mbps", price: "1,799" },
      { speed: "400 Mbps", price: "1,999" },
      { speed: "500 Mbps", price: "2,499" }
    ],
    wirelessPlans: [
      { speed: "30 Mbps", price: "999" },
      { speed: "50 Mbps", price: "1,299", popular: true },
      { speed: "100 Mbps", price: "1,499" }
    ],
    activeTab: "fiber",
    heroWord: "fiber"
  },
  mutations: {
    setActiveTab(state, tab) {
      state.activeTab = tab;
    },
    setHeroWord(state, word) {
      state.heroWord = word;
    }
  },
  actions: {},
  modules: {}
});
